module.exports = __webpack_public_path__ + "img/ellipsis-stroke.f81e65b8.svg";